<div class="fieldset-wrapper symbolratingscale" [ngClass]="
    (isMandatory && isMandatoryUpfront && questions.length == 1) ||
    (isMandatory && isFormSubmit && _isMandatoryInvalid && questions.length == 1)
      ? 'isMandatory'
      : ''
  ">
  <span *ngIf="(isMandatory && isMandatoryUpfront && questions.length == 1) ||
    (isMandatory && isFormSubmit && _isMandatoryInvalid && questions.length == 1)" class="screen-read-only">This
    Question is Required</span>
  <div *ngIf="imgQuestion?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }">
    <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset>
    <legend class="question-option-wrapper"
      [ngClass]="{ 'question-border': imgQuestion?.QuestionImageAndMedia_1 == null && !isMobile }">
      <!-- Hidden Question Tooltip for 2 & 5 population and single question -->
      <span *ngIf="
          isPreview &&
          (questions[0].population_type == 2 || questions[0].population_type == 5) &&
          questions.length == 1
        " class="hidden-question-tooltip-icon hdn-symbol single-ans" appTooltip [dataContext]="''"
        [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0"></span>
      <span *ngIf="isDisplayQno" class="question-no"><strong>{{ imgQuestion.qno }}.</strong></span>
      <span [ngClass]="{
          'question-text': group?.isOverAllStyleApplied,
          'question-text-nb': !group?.isOverAllStyleApplied,
          'no-Qno': !isDisplayQno
        }" id="lbltitle_GQ{{ imgQuestion?.UniqueNumber }}">
        <span *ngIf="questions[0].piping"
          [innerHTML]="getPipingTitle(questions[0]?.group_no) | headerFooterHtml"></span>
        <span *ngIf="!questions[0].piping" [innerHTML]="group?.gtitle | headerFooterHtml"></span>
        <span *ngIf="group?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="group?.QuestionTip"
          [IsButtonPanel]="false" [qid]="imgQuestion?.UniqueNumber" tabindex="0"></span>
                <span class="imgPostPrepop" 
        *ngIf="isQuestionsPostPopulated()"></span>
        <div *ngIf="
            imgQuestion?.hasMedia && imgQuestion?.MediaText != null && imgQuestion?.MediaText != ''
          " class="question-media-text">
          <span>[{{ imgQuestion?.MediaText }}]</span>
        </div>
      </span>
    </legend>
    <div *ngIf="imgQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_2"
        [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <div class="fieldset-wrapper-scroll-cont">
      <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
      <div class="fieldset-wrapper-scroll">
        <div style="display: table; width: 100%" class="answerParent">
          <div class="answer-option-wrapper srs-box {{ getAnsImageCSS() }}">
            <div *ngFor="
                let question of questions | callBack: getHiddenQuestions;
                let i = index;
                trackBy: trackByUniqueNumber
              " class="symbol-subqtn"
              [ngClass]="{
                  'disabled-question': isPostEditDisable(question)
                }">
              <app-answer-media [AnswerMedias]="GetAnswerMedias(question)"></app-answer-media>
              <app-answer-images [AnswerImages]="GetAnswerImages(question)"></app-answer-images>
              <div *ngIf="questions.length >= 1" class="question-option-wrapper subqtn" [ngClass]="
                  (questions.length >= 1 && question.mandatory && isMandatoryUpfront) ||
                  (question.mandatory &&
                    isFormSubmit &&
                    question.isMandatoryInvalid &&
                    questions.length >= 1)
                    ? 'isMandatory'
                    : ''
                ">
                <span *ngIf="(questions.length >= 1 && question.mandatory && isMandatoryUpfront) ||
                  (question.mandatory &&
                    isFormSubmit &&
                    question.isMandatoryInvalid &&
                    questions.length >= 1)" class="screen-read-only">This Question is Required</span>
                <span *ngIf="
                    isPreview &&
                    (question.population_type == 2 || question.population_type == 5) &&
                    questions.length >= 1
                  " class="hidden-question-tooltip-icon hdn-symbol" appTooltip [dataContext]="''"
                  [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0"></span>
                <span *ngIf="question.piping && isDisplaySubQNo" class="question-no"
                  id="lbltitle_R{{ question?.UniqueNumber }}">
                  <span [innerHTML]="question?.pipingQuationTitle | headerFooterHtml"></span>
                  <span *ngIf="question.QuestionTip" class="tooltip_icon" appTooltip
                    [dataContext]="question?.QuestionTip" [IsButtonPanel]="false" [qid]="question?.UniqueNumber"
                    tabindex="0"></span>
                </span>

                <span *ngIf="!question.piping && isDisplaySubQNo" class="srs-question" [ngClass]="{
                    'question-text': question?.isOverAllStyleApplied,
                    'question-text-nb': !question?.isOverAllStyleApplied,
                    'no-Qno': !isDisplayQno
                  }" id="lbltitle_R{{ question?.UniqueNumber }}">
                  <span *ngIf="!question.population_type && isDisplayQno" class="srs-subqno"
                    [ngClass]="{ 'question-no': !isMobile }"
                    [innerHTML]="question?.subQnoinChar | headerFooterHtml"></span>
                  <span [innerHTML]="question?.qtitle | headerFooterHtml"></span>
                  <span *ngIf="question.QuestionTip" class="tooltip_icon" appTooltip
                    [dataContext]="question?.QuestionTip" [IsButtonPanel]="false" [qid]="question?.UniqueNumber"
                    tabindex="0"></span>
                </span>
              </div>
              <div class="symbol-wrapper-parent" [ngClass]="{ 'read-only': question?.population_type == 3 }"
                [ngStyle]="{ 'pointer-events': question?.population_type == 3 ? 'none' : '' }">
                <div class="symbol-wrapper" [attr.symbol-count]="question.Answers.length" [ngClass]="{
                    star: question?.qsubtype == 1,
                    thumbs: question?.qsubtype == 2,
                    hearts: question?.qsubtype == 3,
                    checkmark: question?.qsubtype == 4,
                    dollar: question?.qsubtype == 5,
                    humans: question?.qsubtype == 6,
                    maximumRating: question.Answers.length == 10,
                    ratingNine: question.Answers.length == 9,
                    ratingEight: question.Answers.length == 8,
                    ratingSeven: question.Answers.length == 7,
                    minimumRating: question.Answers.length < 7
                  }">
                  <div class="answer-option" *ngFor="
                      let answers of question?.Answers;
                      let j = index;
                      trackBy: trackByValueId
                    " [ngClass]="question?.qtype == 'HR' ? 'horizontal-radio' : ''" [ngClass]="
                      answers?.hasImage && answers?.AnswerImages.length == 1
                        ? 'single-ans-image'
                        : answers?.hasImage && answers?.AnswerImages.length == 2
                          ? 'multi-ans-image'
                          : ''
                    ">
                    <input type="radio" [disabled]="answers?.isQuotaDisable"
                      [attr.name]="'Q' + question?.qno + '_' + question?.UniqueNumber + '_R_NAME'"
                      name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_NAME" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                        answers?.value_id
                      }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns"
                      (click)="clickEventHandle(answers, question, $event.target)" [attr.weight]="answers.weight"
                      [attr.aria-label]="answers.value_text" (change)="nextQuestion($event.target)"
                      [attr.aria-required]="
                        (question.mandatory && isMandatoryUpfront) ||
                        (question.mandatory && isFormSubmit && question.isMandatoryInvalid)
                      " />

                    <label [ngClass]="
                        answers.value_id <= question.selectAnsValue ? 'selectedSymbol' : ''
                      " for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                        answers?.value_id
                      }}_ID" aria-hidden="true">
                      <span class="lblReadValue" [innerText]="answers.weight"></span>
                    </label>
                  </div>
                </div>
              </div>
              <ng-template #SymbolTextpopulation>
                <div class="symbol-wrapper" [attr.symbol-count]="question.Answers.length" [ngClass]="{
                    star: question?.qsubtype == 1,
                    thumbs: question?.qsubtype == 2,
                    hearts: question?.qsubtype == 3,
                    checkmark: question?.qsubtype == 4,
                    dollar: question?.qsubtype == 5,
                    humans: question?.qsubtype == 6,
                    maximumRating: question.Answers.length == 10,
                    ratingNine: question.Answers.length == 9,
                    ratingEight: question.Answers.length == 8,
                    ratingSeven: question.Answers.length == 7,
                    minimumRating: question.Answers.length < 7
                  }">
                  <div class="answer-option" *ngFor="let answers of question?.Answers; let i = index"
                    [ngClass]="question?.qtype == 'HR' ? 'horizontal-radio' : ''" [ngClass]="
                      answers?.hasImage && answers?.AnswerImages.length == 1
                        ? 'single-ans-image'
                        : answers?.hasImage && answers?.AnswerImages.length == 2
                          ? 'multi-ans-image'
                          : ''
                    ">
                    <div *ngIf="answers.value_id <= question.selectAnsValue">
                      <input type="radio" [disabled]="true"
                        [attr.name]="'Q' + question?.qno + '_' + question?.UniqueNumber + '_R_NAME'"
                        name="Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_NAME" id="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                          answers?.value_id
                        }}_ID" value="{{ answers.value_text }}" [(ngModel)]="answers.ControlAns"
                        [attr.weight]="answers.weight" [attr.aria-label]="answers.value_text" />

                      <label [ngClass]="
                          answers.value_id <= question.selectAnsValue ? 'selectedSymbol' : ''
                        " for="lbl_Q{{ question?.qno }}_{{ question?.UniqueNumber }}_R_{{
                          answers?.value_id
                        }}_ID">
                        <span class="lblReadValue" [innerText]="answers.weight"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </ng-template>

              <div *ngIf="isNgOnChange && count == 0">{{ ngOnChangesEventHandle(i) }}</div>
            </div>
            <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
              <div *ngIf="showNewParticipationButton || questions.length >= 1" class="ques-response-btn-div">
                <button *ngIf="isAnsChange || isPreReadQn" type="button" class="ques-response-btn"
                  (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
                  (click)="gotoNextQuestion(questions[0], $event.target)">
                  {{ newParticipationBtnText }}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>